<template>
  <v-container fluid>
    <v-card flat>
      <v-app-bar flat dense :color="$store.state.UiColors.crudToolbarDetail">
        <v-icon>new_releases</v-icon>
        <v-toolbar-title class="font-weight-light"
          >Alta/Modificación de Prospectos</v-toolbar-title
        >
        <v-spacer></v-spacer>

        <!-- <v-btn v-if="!editMode" :color="$store.state.UiColors.crudToolbarDetailButtons" fab small top @click="editItem()" v-show="canCreate">                        
                <v-icon  medium>add_circle_outline</v-icon>
                </v-btn> -->
        <v-btn
          v-if="model.id != null"
          :color="$store.state.UiColors.crudToolbarDetailButtons"
          fab
          small
          top
          @click="editMode = !editMode"
          v-show="canUpdate">
          <v-icon v-if="editMode">cancel</v-icon>
          <v-icon v-else>edit</v-icon>
        </v-btn>
      </v-app-bar>
      <v-card-text>
        <v-container fluid>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="model.nombre"
                label="Nombre"
                required
                :disabled="!editMode"
                v-validate="'required'"
                data-vv-name="nombre"
                :error-messages="errors.collect('nombre')"></v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                v-model="model.documento"
                label="Documento"
                :disabled="!editMode"
                v-validate="'required'"
                data-vv-name="documento"
                :error-messages="errors.collect('documento')"></v-text-field>
            </v-col>
          </v-row>

          <v-row v-if="validacionGeografica" align="center" dense>
            <v-col cols="5">
              <v-text-field
                v-model="telefonoEditor.numero"
                label="Teléfono"
                v-validate="'required'"
                data-vv-name="numero"
                counter>
                <template
                  v-slot:append
                  v-if="!telefonoEditor.telefonoValidado && !validando">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon v-on="on" @click="validarTelefono"
                        >help_outline</v-icon
                      >
                    </template>
                    <span
                      >Ingresar los 10 números del teléfono (sin el 15 ni el '0'
                      delante del código de área) y presione para validar</span
                    >
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>

            <v-col cols="1">
              <v-icon v-if="telefonoEditor.telefonoValidado" color="green"
                >check_circle_outline</v-icon
              >
              <v-icon v-else-if="validando" color="grey">update</v-icon>
            </v-col>
            <v-col
              v-if="
                resultadoValidacion.esValido == false &&
                resultadoValidacion.motivoNoValida
              ">
              <v-chip class="caption" color="red" dark>{{
                resultadoValidacion.motivoNoValida
              }}</v-chip>
            </v-col>

            <v-col cols="6">
              <v-text-field
                v-model="model.email"
                label="Email"
                :disabled="!editMode"></v-text-field>
            </v-col>
          </v-row>

          <!-- <v-row>
            <v-col cols="4">
              <v-text-field
                v-model="model.edad"
                label="Edad"
                :disabled="!editMode"
              ></v-text-field>
            </v-col>

            <v-col cols="4">
              <v-text-field
                v-model="model.ingresos"
                label="Ingresos"
                :disabled="!editMode"
              ></v-text-field>
            </v-col>

            <v-col cols="4">
              <v-autocomplete
                v-model="model.sexoId"
                :items="listSexos"
                :disabled="!editMode"
                item-text="descripcion"
                item-value="id"
                label="Sexo"
                :menu-props="{ minWidth: '200' }"
              ></v-autocomplete>
            </v-col>
          </v-row> -->

          <!-- <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="model.montoSolicitado"
                label="Monto Solicitado"
                :disabled="!editMode"
              ></v-text-field>
            </v-col>

            <v-col cols="6">
              <v-text-field
                v-model="model.cuotaMaxima"
                label="Cuota Máxima"
                :disabled="!editMode"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6">
              <v-autocomplete
                v-model="model.formaLlegadaId"
                :items="listFormasLlegada"
                :disabled="!editMode"
                item-text="descripcion"
                item-value="id"
                label="Forma de Llegada"
                :menu-props="{ minWidth: '200' }"
              ></v-autocomplete>
            </v-col>
          </v-row> -->

          <v-row>
            <v-col cols="6">
              <v-autocomplete
                v-model="model.destinoCreditoId"
                :items="listMotivosProspecto"
                :disabled="!editMode"
                item-text="descripcion"
                item-value="id"
                label="Motivo del Crédito"
                :menu-props="{ minWidth: '200' }"></v-autocomplete>
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                v-model="model.canalVentaId"
                :items="listCanalesVenta"
                autocomplete="disabled"
                item-text="nombre"
                item-value="id"
                :disabled="!editMode"
                label="Canal de Venta"></v-autocomplete>
            </v-col>

            <v-col cols="8">
              <v-autocomplete
                v-model="model.formaLlegadaId"
                :items="listFormasLlegada"
                autocomplete="disabled"
                item-text="descripcion"
                item-value="id"
                :disabled="!editMode"
                label="¿Cómo llegó a la sucursal?"></v-autocomplete>
            </v-col>

            <!-- <v-col cols="6">
              <v-autocomplete
                v-model="model.respuestaConsultaId"
                :items="listRespuestasConsulta"
                :disabled="!editMode"
                item-text="descripcion"
                item-value="id"
                label="Respuesta"
                :menu-props="{ minWidth: '200' }"
              ></v-autocomplete>
            </v-col> -->
          </v-row>

          <!-- <v-row>
            <v-col cols="4">
              <v-text-field
                v-model="model.score"
                label="Score"
                :disabled="!editMode"
              ></v-text-field>
            </v-col>

            <v-col cols="4">
              <v-checkbox
                v-model="model.aprobado"
                label="Aprobado"
                :disabled="!editMode"
              ></v-checkbox>
            </v-col>
          </v-row> -->

          <v-row>
            <v-textarea
              v-model="model.comentarios"
              class="mx-2"
              label="Comentarios"
              prepend-icon="comment"
              clearable
              auto-grow
              :disabled="!editMode">
            </v-textarea>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="blue darken-1" text @click.stop="hide(false)"
          >Cerrar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click.stop="guardar"
          :disabled="!editMode"
          >Guardar</v-btn
        >
      </v-card-actions>
    </v-card>
    <template v-if="$store.state.debugModeOn">
      Debug Info:
      <p></p>

      Editor: {{ telefonoEditor }}
      <p></p>
      Validacion: {{ resultadoValidacion }}
      <p></p>
    </template>

    <template v-if="$store.state.debugModeOn">
      Debug Info:
      <p></p>

      Model: {{ model }}
      <p></p>
    </template>
  </v-container>
</template>

<script>
import Vue from "vue";
import { http } from "@/axios";

import { mapGetters, mapMutations } from "vuex";

export default {
  data: () => ({
    model: {
      nombre: "",
      documento: "",
      telefono: "",
      edad: 1,
      ingresos: 1,
      sexoId: "",
      montoSolicitado: 1,
      cuotaMaxima: 1,
      canalVentaId: 0,
      formaLlegadaId: 0,
    },
    telefonoEditor: {
      numero: "",
      perteneceA: {},
      estaVerificado: false,
      codigoVerificacionTemporal: "",
    },
    created: false,
    loading: false,
    listFormasLlegada: [],
    listSexos: [],
    listMotivosProspecto: [],
    listRespuestasConsulta: [],
    listCanalesVenta: [],
    //listTiposViaIngreso: [],
    editMode: false,
    validando: false,
    resultadoValidacion: { esValido: true },
  }),
  props: {
    editModeProp: { type: Boolean, default: false },
    prospectoId: { type: String },
    isSubTask: { type: Boolean, default: false },
    visible: { type: Boolean, default: false },
    editProspecto: { type: Object, default: null },
  },

  async created() {
    // alert("ID: " + this.prospectoId);
    // alert("PropsID: " + this.props.prospectoId);

    //this.props.prospectoId = this.prospectoId;
    Vue.$log.debug(this.editModeProp);
    this.editMode = this.editModeProp;

    // this.validacionGeografica =
    //   this.$store.state.parametrosGenerales.validacionGeograficaTelefono;

    await this.loadFormasLlegada();
    await this.loadSexos();
    await this.loadMotivosProspecto();
    await this.loadRespuestasConsulta();
    await this.loadCanalesVenta();
    await this.loadFormasLlegada();

    console.log("Reached before loadProspecto");

    if (this.prospectoId) {
      await this.loadProspecto(this.prospectoId);
    }

    // console.log('this.editProspecto')
    // console.log(this.editProspecto)

    if (this.editProspecto) {
      this.model.nombre = this.editProspecto.nombre;
      this.model.documento = this.editProspecto.documento;
      this.model.edad = this.editProspecto.fechaNacimiento;
      this.model.ingresos = this.editProspecto.ingresos;
      this.model.sexoId = this.editProspecto.sexoId;
      this.model.montoSolicitado = this.editProspecto.montoSolicitado;
      this.model.cuotaMaxima = this.editProspecto.cuotaMaxima;
      this.model.formaLlegada = this.editProspecto.formaLlegadaId;
    }

    this.telefonoEditor.esValido = true;

    this.telefonoEditor.telefonoValidado = true;
    this.telefonoEditor.numero = this.editProspecto.telefono;
  },
  computed: {
    ...mapGetters([
      "checkCanCreate",
      "checkCanUpdate",
      "checkCanDelete",
      "getActionFromLink",
      "user",
    ]),
    canCreate: function () {
      return this.checkCanCreate(this.$route.path);
    },
    canUpdate: function () {
      return this.checkCanUpdate(this.$route.path);
    },
    canDelete: function () {
      return this.checkCanDelete(this.$route.path);
    },
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
  },
  watch: {
    "telefonoEditor.numero": function () {
      Vue.$log.debug("telefonoEditor.numero changed");
      if (!this.resultadoValidacion.esValido) {
        this.telefonoEditor.telefonoValidado = false;
      }

      this.resultadoValidacion.esValido = false;
    },

    async prospectoId(newId) {
      // alert("NwId");
      if (newId) {
        await this.loadProspecto(newId);
        this.fillModel();
      }
    },
  },

  methods: {
    ...mapMutations([
      "setActiveTask",
      "setActiveSubTask",
      "hideActiveTask",
      "hideActiveSubTask",
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
    ]),
    async guardar() {
      if (!this.validarIngreso()) return;

      this.loading = true;
      //let isUpdate = this.model.id != "00000000-0000-0000-0000-000000000000";

      let isUpdate =
        this.model &&
        this.model.id &&
        this.model.id !== "00000000-0000-0000-0000-000000000000";

      try {
        if (isUpdate)
          await http.put(
            "prospectos",
            JSON.stringify({ prospecto: this.model }),
          );
        else {
          this.model.responsableId = this.user.id;
          await http.post(
            "prospectos",
            JSON.stringify({ prospecto: this.model }),
          );
        }

        this.alertSuccess("Se ha guardado la información del prospecto.");

        this.hide(true);
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
      await this.$validator.validateAll();

      if (this.errors.items.length > 0) {
        this.alertWarning(this.errors.msg);
        return;
      }
      this.loading = false;

      if (this.validacionGeografica && !this.telefonoEditor.telefonoValidado) {
        this.alertWarning("Por favor, valide el teléfono antes de confirmar.");
        return;
      }
      this.loading = false;

      this.copiarTelefono(this.telefonoEditor, this.telefono);
    },

    validarIngreso() {
      if (
        isNaN(parseInt(this.model.documento)) ||
        this.model.documento.length < 7 ||
        this.model.documento.length > 8
      ) {
        this.alertWarning("Verifique el documento ingresado.");
        return false;
      }

      if (!this.model.nombre) {
        this.alertWarning("Debe ingresar el nombre del prospecto.");
        return false;
      }

      // if (!this.model.formaLlegadaId) {
      //   this.alertWarning('Debe elegir un tipo de forma de llegada.');
      //   return false;
      // }

      // if (!this.model.sexoId) {
      //   this.alertWarning('Debe elegir el sexo del prospecto.');
      //   return false;
      // }

      // Vue.$log.debug(parseInt(this.model.edad));

      // if (isNaN(parseInt(this.model.edad))) {
      //   this.alertWarning('Verifique la edad ingresada.');
      //   return false;
      // }

      return true;
    },
    async loadProspecto() {
      this.loading = true;
      try {
        var result = await http.get("prospectos/" + this.prospectoId);
        this.model = result;

        this.telefonoEditor.esValido = true;

        this.telefonoEditor.telefonoValidado = true;
        this.telefonoEditor.numero = this.model.telefono;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadCanalesVenta() {
      this.loading = true;
      try {
        var result = await http.get(
          "canalesventa/canalesventacomercializadores",
        ); // traigo todas
        this.listCanalesVenta = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    async loadFormasLlegada() {
      this.loading = true;
      try {
        var result = await http.get("tiposFormaLlegadaProspecto"); // traigo todas
        this.listFormasLlegada = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },

    async editItem() {
      this.editMode = true;
    },
    async loadMotivosProspecto() {
      this.loading = true;
      try {
        var result = await http.get("tiposmotivoprospecto");
        this.listMotivosProspecto = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadRespuestasConsulta() {
      this.loading = true;
      try {
        var result = await http.get("tiposrespuestaconsulta");
        this.listRespuestasConsulta = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    // async loadFormasLlegada() {
    //   this.loading = true;
    //   try {
    //     var result = await http.get("tiposformallegada"); // traigo todas
    //     this.listFormasLlegada = result.list;
    //   } catch (error) {
    //     // Error
    //     this.alertError(error);
    //   }
    //   this.loading = false;
    // },
    async loadSexos() {
      this.loading = true;
      try {
        var result = await http.get("tipossexo"); // traigo todas
        this.listSexos = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
        this.alertError(error);
      }
      this.loading = false;
    },
    async validarTelefono() {
      if (!this.telefonoEditor.numero) {
        this.alertWarning("Debe ingresar el número de teléfono a validar.");
        return;
      }

      this.validando = true;

      try {
        var result = await http.get(
          "BusinessCore/validartelefonobasegeografica" +
            "?telefono=" +
            this.telefonoEditor.numero,
        );

        if (result.esValido) {
          this.telefonoEditor.numero = result.numeroFormateado;
          this.model.telefono = result.numeroFormateado;
        }

        this.telefonoEditor.esValido = result.esValido;
        this.telefonoEditor.telediscado = result.numeroPuro;
        this.telefonoEditor.telefonoValidado = result.esValido;
        this.telefonoEditor.esCelular = !result.esFijo;

        this.resultadoValidacion = result;
      } catch (error) {
        // Error
        this.alertError(error);
        Vue.$log.error(error);
      }
      this.validando = false;
    },
    hide(cerrarRelacionados) {
      //esto lo hago para que no se buguee cuando lo abro como subtask o task
      if (this.isSubTask) this.hideActiveSubTask();
      else this.hideActiveTask(cerrarRelacionados);
    },
  },
};
</script>
